// ** Icons Import
import { Home, Circle } from 'react-feather';

export default [
    {
        id: 'item',
        title: 'Item',
        icon: <Home size={20} />,
        navLink: '/item'
    }
];
